import gql from 'graphql-tag'

export const DESTROY_SURVEY = gql`
  mutation DestroySurvey($surveyId: Int!) {
    destroySurvey(surveyId: $surveyId) {
      id
    }
  }
`

export const OFFICIALIZE_SURVEY = gql`
  mutation OfficializeSurvey($surveyId: Int!) {
    officializeSurvey(surveyId: $surveyId) {
      id
    }
  }
`
